import SideBar from "./components/SideBar";
import Header from "../src/components/Header";
import Footer from "../src/components/Footer";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <div className="app-container">
        <div className="sidebar-container">
          <SideBar />
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            bodyClassName="toastBody"
          />
        </div>
     
        <div className="content-container">
          <Header />
           
          <Outlet />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
